import { render, staticRenderFns } from "./join-video.vue?vue&type=template&id=7ae421a1"
import script from "./join-video.vue?vue&type=script&lang=js"
export * from "./join-video.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports